"use client";

import { c as _c } from "react/compiler-runtime";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import type { RefObject } from "react";
type VoteFeedbackSource = "custom-submit" | "quick-amount";
const CUSTOM_AMOUNT_CONTROL_LABEL = "Change vote amount";
interface MemesQuickVoteCustomAmountRowProps {
  readonly customAmountLabel: string | null;
  readonly customInputRef: RefObject<HTMLInputElement | null>;
  readonly customValue: string;
  readonly feedbackSource: VoteFeedbackSource | null;
  readonly hasQuickAmounts: boolean;
  readonly isCustomRowVisible: boolean;
  readonly isSubmitting: boolean;
  readonly isVoteFeedbackActive: boolean;
  readonly onCustomChange: (value: string) => void;
  readonly onCustomSubmit: () => void;
  readonly onToggleCustom: () => void;
  readonly votingLabel: string | null;
}
export default function MemesQuickVoteCustomAmountRow(t0) {
  const $ = _c(46);
  const {
    customAmountLabel,
    customInputRef,
    customValue,
    feedbackSource,
    hasQuickAmounts,
    isCustomRowVisible,
    isSubmitting,
    isVoteFeedbackActive,
    onCustomChange,
    onCustomSubmit,
    onToggleCustom,
    votingLabel
  } = t0;
  const t1 = isSubmitting && "tw-cursor-not-allowed tw-opacity-60";
  const t2 = isVoteFeedbackActive ? "tw-border-emerald-500/30 tw-bg-[#06110d]" : "focus-within:tw-border-primary-400";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = clsx("tw-relative tw-flex tw-h-full tw-w-full tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-iron-900 tw-bg-black tw-transition-colors desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:focus-within:tw-border-primary-400", t1, t2);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-sr-only">{CUSTOM_AMOUNT_CONTROL_LABEL}</span>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = isCustomRowVisible ? undefined : -1;
  let t6;
  if ($[4] !== onCustomChange) {
    t6 = event => onCustomChange(event.target.value);
    $[4] = onCustomChange;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== onCustomSubmit) {
    t7 = event_0 => {
      if (event_0.key !== "Enter") {
        return;
      }
      event_0.preventDefault();
      onCustomSubmit();
    };
    $[6] = onCustomSubmit;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== customInputRef || $[9] !== customValue || $[10] !== isSubmitting || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <input ref={customInputRef} type="text" aria-label={CUSTOM_AMOUNT_CONTROL_LABEL} inputMode="numeric" pattern="[0-9]*" value={customValue} disabled={isSubmitting} tabIndex={t5} onChange={t6} onKeyDown={t7} className="tw-form-input tw-h-full tw-w-full tw-border-0 tw-bg-transparent tw-px-3 tw-pr-16 tw-text-base tw-font-semibold tw-text-iron-50 tw-outline-none tw-ring-0 focus:tw-ring-0 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 sm:tw-px-4 sm:tw-pr-20" />;
    $[8] = customInputRef;
    $[9] = customValue;
    $[10] = isSubmitting;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = votingLabel ?? "Votes";
  let t10;
  if ($[15] !== t9) {
    t10 = <span className="tw-pointer-events-none tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-xs tw-font-bold tw-text-iron-500 sm:tw-right-4">{t9}</span>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t8) {
    t11 = <div className="tw-relative tw-h-full tw-w-full">{t8}{t10}</div>;
    $[17] = t10;
    $[18] = t8;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t3) {
    t12 = <label className={t3}>{t4}{t11}</label>;
    $[20] = t11;
    $[21] = t3;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = customAmountLabel ? `Vote ${customAmountLabel}` : "Vote";
  let t14;
  if ($[23] !== onCustomSubmit) {
    t14 = () => {
      onCustomSubmit();
    };
    $[23] = onCustomSubmit;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const t15 = isCustomRowVisible ? undefined : -1;
  const t16 = isVoteFeedbackActive && feedbackSource === "custom-submit" ? "tw-border tw-border-solid tw-border-emerald-500/40 tw-bg-emerald-500/15 tw-text-emerald-100 tw-shadow-[0_0_20px_rgba(16,185,129,0.18)]" : "tw-border-0 tw-bg-primary-600 tw-text-white tw-shadow-[0_12px_24px_rgba(37,99,235,0.28)] desktop-hover:hover:tw-bg-primary-500";
  let t17;
  if ($[25] !== t16) {
    t17 = clsx("tw-inline-flex tw-h-full tw-shrink-0 tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-xl tw-px-5 tw-text-sm tw-font-bold tw-tracking-wide tw-transition-all active:tw-scale-95 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 sm:tw-px-6 md:tw-px-4 lg:tw-px-6", t16);
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== feedbackSource || $[28] !== isVoteFeedbackActive) {
    t18 = isVoteFeedbackActive && feedbackSource === "custom-submit" ? <span className="tw-inline-flex tw-items-center tw-gap-1.5"><CheckIcon className="tw-size-4 tw-shrink-0" /><span>Voted</span></span> : "Vote";
    $[27] = feedbackSource;
    $[28] = isVoteFeedbackActive;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== isSubmitting || $[31] !== t13 || $[32] !== t14 || $[33] !== t15 || $[34] !== t17 || $[35] !== t18) {
    t19 = <button type="button" aria-label={t13} onClick={t14} disabled={isSubmitting} tabIndex={t15} className={t17}>{t18}</button>;
    $[30] = isSubmitting;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== hasQuickAmounts || $[38] !== isCustomRowVisible || $[39] !== isSubmitting || $[40] !== onToggleCustom) {
    t20 = hasQuickAmounts && <button type="button" aria-label={`Close ${CUSTOM_AMOUNT_CONTROL_LABEL.toLowerCase()}`} onClick={onToggleCustom} disabled={isSubmitting} tabIndex={isCustomRowVisible ? undefined : -1} className="tw-inline-flex tw-h-full tw-w-11 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-white/10 tw-bg-white/[0.06] tw-text-iron-400 tw-transition-all active:tw-scale-95 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 desktop-hover:hover:tw-bg-white/10 desktop-hover:hover:tw-text-white sm:tw-w-12"><XMarkIcon className="tw-size-5 tw-flex-shrink-0" /></button>;
    $[37] = hasQuickAmounts;
    $[38] = isCustomRowVisible;
    $[39] = isSubmitting;
    $[40] = onToggleCustom;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t12 || $[43] !== t19 || $[44] !== t20) {
    t21 = <div className="tw-flex tw-h-full tw-items-stretch tw-gap-1.5 sm:tw-gap-2">{t12}{t19}{t20}</div>;
    $[42] = t12;
    $[43] = t19;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  return t21;
}